import { AsyncStatus } from 'lib-shared-legacy-types';
import { handleActions } from 'redux-actions';

import { templatesActions } from '../../actions/templates';

const { templatesRender, templatesRenderSucceeded, templatesRenderFailed } =
  templatesActions;

export type TemplatesStates = {
  templatesList: Array<any>;
  meta: {
    render: AsyncStatus;
    sortType: string;
  };
  ui: {
    isEditModalOpen: boolean;
    isConfirmModalOpen: boolean;
  };
};

const initialState: TemplatesStates = {
  templatesList: [],
  meta: {
    render: 'succeeded',
    sortType: 'Most popular',
  },
  ui: {
    isEditModalOpen: false,
    isConfirmModalOpen: false,
  },
};

// Reducer
export const templates = handleActions<TemplatesStates, any>(
  {
    [templatesRender.toString()]: (state: TemplatesStates, action: any) => {
      return { ...state, meta: { ...state.meta, render: 'loading' } };
    },

    [templatesRenderSucceeded.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return { ...state, meta: { ...state.meta, render: 'succeeded' } };
    },

    [templatesRenderFailed.toString()]: (
      state: TemplatesStates,
      action: any,
    ) => {
      return { ...state, meta: { ...state.meta, render: 'failed' } };
    },
  },
  initialState,
);
